/** Ícones do shell do admin — mesma família traço de `apps/painel/.../Icons.tsx` (portada 1:1
 *  onde o significado é o mesmo; 2 ícones novos pra telas que só existem aqui). */
import type { SVGProps } from 'react';

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export function BrandMark(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2.4} {...p}>
      <path d="M4 7h16l-1.2 11.2A2 2 0 0 1 16.8 20H7.2a2 2 0 0 1-2-1.8L4 7Z" />
      <path d="M8.5 7V5.5a3.5 3.5 0 0 1 7 0V7" />
    </svg>
  );
}

export function IconVisaoGeral(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <rect x="3.5" y="3.5" width="7" height="9" rx="1.4" />
      <rect x="13.5" y="3.5" width="7" height="5.5" rx="1.4" />
      <rect x="13.5" y="12" width="7" height="8.5" rx="1.4" />
      <rect x="3.5" y="15.5" width="7" height="5" rx="1.4" />
    </svg>
  );
}

export function IconParceiros(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20v-1a6 6 0 0 1 12 0v1" />
      <path d="M16 5.2a3 3 0 0 1 0 5.6" />
      <path d="M18.5 14a5.5 5.5 0 0 1 3.5 5v1h-3" />
    </svg>
  );
}

export function IconSaude(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M3 12h4l2-7 4 14 2-7h6" />
    </svg>
  );
}

export function IconSun(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4" />
    </svg>
  );
}

export function IconBell(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={1.8} {...p}>
      <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </svg>
  );
}

export function IconSearch(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export function IconExit(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={1.9} {...p}>
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
      <path d="M10 17l5-5-5-5" />
      <path d="M15 12H3" />
    </svg>
  );
}
